module.exports = __webpack_public_path__ + "static/media/joe.563000c3.jpeg";